export const SAVE = '@user/SAVE';
export const FETCH = '@user/FETCH';
export const UPDATE = '@user/UPDATE';
export const REMOVE = '@user/REMOVE';
